<script>
import { uniqid } from '~/assets/js/methods'

export default {
    name: 'InitGatewaysScript',
    methods: {
        initMercadoPago() {
            console.warn('initMercadoPago');
            // manually add the script to the DOM
            const script = document.createElement('script')
            script.src = 'https://sdk.mercadopago.com/js/v2'
            document.head.appendChild(script)

        },
        initMercadoPagoSecurity() {
            console.warn('initMercadoPago Security');
            // manually add the script to the DOM
            const script = document.createElement('script')
            script.src = 'https://www.mercadopago.com/v2/security.js'
            script.view = 'checkout'
            document.head.appendChild(script)

        },
        initAbmex() {
            // ESSA INTEGRAÇÃO NÃO FUNCIONA MAIS COM O SCRIPT QUE ESTAVA AQUI
        },
        initPayBeehive() {
            // manually add the script to the DOM
            const script = document.createElement('script')
            script.src = 'https://api.conta.paybeehive.com.br/v1/js'
            document.head.appendChild(script)

        },
        initDomPagamentos() {
            // manually add the script to the DOM
            const script = document.createElement('script')
            script.src = 'https://api.dompagamentos.com.br/v1/js'
            document.head.appendChild(script)

        },
        initDomPagamentosV3() {
            // manually add the script to the DOM
            const script = document.createElement('script')
            script.src = 'https://apiv3.dompagamentos.com.br/js/sdk-dompagamentos.min.js'
            document.head.appendChild(script)

        },
        initUnicoPag() {
            const script = document.createElement('script')
            script.src = 'https://js.iugu.com/v2'
            document.head.appendChild(script)
        },
        initShield() {
            const script = document.createElement('script')
            script.src = 'https://api.shieldtecnologia.com/v1/js'
            document.head.appendChild(script)
        },
        initBarte() {

            if (process.env.NODE_ENV === 'production') {
                var attempt_reference = uniqid("unicopag.", true);
                if (attempt_reference) {
                    const nethoneScript = document.createElement("script");
                    nethoneScript.type = "text/javascript";
                    nethoneScript.id = "nethone-script";
                    nethoneScript.crossOrigin = "use-credentials";
                    nethoneScript.src = "https://d354c9v5bptm0r.cloudfront.net/s/68741/dQItJr.js";
                    nethoneScript.async = true;
                    document.body.appendChild(nethoneScript);
                    nethoneScript.onload = () => {
                        localStorage.setItem("attempt_reference", attempt_reference);
                            const nethoneOptions = {
                                attemptReference: attempt_reference,
                                sensitiveFields: ["name", "card_cvv", "card_expiration", "card_number"],
                        };
                        if (window.dftp) {
                            window.dftp.init(nethoneOptions);
                        } else {
                            nethoneScript.addEventListener("load", () => {
                                if (window.dftp) {
                                    window.dftp.init(nethoneOptions);
                                }
                            });
                        }
                    }
                }
            }

        },
        initPagarmev2() {
            const script = document.createElement('script');
            script.src = 'https://checkout.pagar.me/v1/tokenizecard.js';
            script.setAttribute('data-pagarmecheckout-app-id', '');
            script.async = true;
            document.body.appendChild(script);
        }
    },
    mounted() {
        this.initMercadoPagoSecurity();
        this.initBarte();
        this.initUnicoPag();
        this.initShield();
        setTimeout(() => {
            setTimeout(() => {
                this.initPayBeehive();
            }, 1000);

            setTimeout(() => {
                this.initDomPagamentos();
                this.initDomPagamentosV3();
                this.initPagarmev2();
            }, 1000);

        }, 1500);

        setTimeout(() => {
            this.initMercadoPago();
        }, 1500);
    },
    data() {
        return {
            abmex: false,
            noxpay: false,
            mercadopago: false,
            pagarmev2: false,
        }
    }
}
</script>

<template>
    <div>
    </div>
</template>
